export const COLORS = {
  background: "#E7ECFC"
}